import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */

const controller = "/configuracao";

/**
 * Classe de gerenciamento de chamadas da API de chamada de senha
 *
 * @class
 */
export default class ConfiguracaoApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe ConfiguracaoApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */

  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Busca a estação do telão usado
   * @returns objeto da estação do telão
   */

  async buscarEstacao() {
    try {
      const resp = await this.api<any>(`${controller}/RecuperarNomeEstacao`, {
        method: "GET",
      });
      return resp;
    } catch (error) {
      console.error("Erro ao buscar a lista de telões:", error);
      return null;
    }
  }
}
